import { render, staticRenderFns } from "./Documentlist.vue?vue&type=template&id=39a9336a"
import script from "./Documentlist.vue?vue&type=script&lang=js"
export * from "./Documentlist.vue?vue&type=script&lang=js"
import style0 from "./Documentlist.vue?vue&type=style&index=0&id=39a9336a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports